import React from 'react';
import styles from './SingleBlog.module.scss';
import SingleHero from './SingleHero/SingleHero';
import MainContent from './MainContent/MainContent';
import { useRouter } from 'next/router';
import { getObjFrmArray } from '../../../../commons/utils/utils';
import RelatedArticle from './RelatedArticle/RelatedArticle';
import Head from 'next/head';

export default function SingleBlog({
  categories = [],
  tags = [],
  currentPost = {},
  relatedBlogs = [],
  extraMeta = {},
}) {
  const router = useRouter();
  const currentPathname = router.pathname.split('/')[1];
  const categoryPostCount = getObjFrmArray(
    categories,
    'id',
    currentPost?.categories[0]
  );

  return (
    <>
      {Object.keys(currentPost).length > 0 && (
        <>
          <Head>
            <title>{currentPost?.title?.rendered}</title>
            <meta
              property="og:title"
              content={
                currentPost?.custom_fields?.seo_title ||
                currentPost?.title?.rendered
              }
              key="ogtitle"
            />
            <meta
              name="description"
              content={
                currentPost?.custom_fields?.seo_description ||
                currentPost?.custom_fields?.custom_except
              }
            />
            <meta
              property="og:description"
              content={
                currentPost?.custom_fields?.seo_description ||
                currentPost?.custom_fields?.custom_except
              }
              key="ogdesc"
            />
            <meta
              property="og:url"
              content={`${extraMeta.ogUrl}`}
              key="ogurl"
            />
            <meta
              property="og:image"
              content={currentPost?.featured_image?.url}
              key="ogimage"
            />
            <link
              key="canonical-url"
              rel="canonical"
              href={`${extraMeta.ogUrl}`}
            />
          </Head>
          <SingleHero data={currentPost} />
          <MainContent
            data={currentPost}
            tagsList={tags}
            currentPathname={currentPathname}
          />
          {categoryPostCount?.count > 1 && (
            <div className={styles.relatedArticleWrapper}>
              <RelatedArticle
                data={currentPost}
                categoryList={categories}
                relatedBlogs={relatedBlogs}
              />
            </div>
          )}
        </>
      )}
    </>
  );
}
